import { Typography } from '../../../Typography';
import { Box } from '../../../Box';

/**
 * Свойства компонента {@link FileError}
 */
interface FileErrorProps {
  /**
   * Текст ошибки.
   */
  text: string;
}

/**
 * FileError - компонент для отображения ошибки файла.
 *
 * @public
 * @param text - Текст ошибки.
 * @returns Возвращает JSX-элемент представляющий компонент FileError.
 *
 * @remarks
 *
 * Ссылка на свойства компонента {@link FileErrorProps}
 */
export const FileError = ({ text }: FileErrorProps) => {
  return (
    <Box pt="4" display="flex" justifyItems="center">
      <Typography variant="caption" color="accent.text.error">
        {text || 'Что-то пошло не так'}
      </Typography>
    </Box>
  );
};
